var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3342C8 11.5312 8 11.6298 7.99268 11.7151C7.91655 12.6022 7.26324 13.3321 6.39002 13.5057C6.30602 13.5224 6.20801 13.5333 6.01223 13.5551L5.3313 13.6307C4.30832 13.7444 3.7968 13.8012 3.39044 13.6712C2.84862 13.4978 2.40628 13.1019 2.17412 12.5825C2 12.193 2 11.6783 2 10.6491V5.35265C2 4.32336 2 3.80872 2.17412 3.4192C2.40628 2.89984 2.84862 2.50392 3.39044 2.33054C3.79681 2.2005 4.3083 2.25733 5.33129 2.371L6.01223 2.44666C6.20808 2.46842 6.306 2.4793 6.39002 2.49601C7.26324 2.66963 7.91655 3.39955 7.99268 4.28659C8 4.37194 8 4.47047 8 4.66752",
    stroke: "#02698C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.3327L14 7.99935M14 7.99935L10.6667 4.66602M14 7.99935H6",
    stroke: "#02698C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOut);
export default __webpack_public_path__ + "static/media/IconLogOut.a44aeb5a08738cc2276930270df49257.svg";
export { ForwardRef as ReactComponent };